"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultProps = {};
exports.default = defaultProps;
//# sourceMappingURL=defaultProps.js.map